export default {"src":"/_next/static/media/0x692c57641fc054c2ad6551ccc6566eba599de1ba.cf54c71c.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};